import { Modal, Button } from "antd";
import React, { useState } from "react";
import { triggerNotification, useGetApiRequests } from "../../../common/CommonExport";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function LeaveRequestConfirmation(props: any) {
  const { closeConfirmationModal, setCloseConfirmationModal, type, setType, approvalObject, getLeavePolicyApi } = props;
  const [open, setOpen] = useState(closeConfirmationModal);
  const leavePloicyApprovalApi = useGetApiRequests("updateLeaveRequest", "PUT");
  const { search } = useLocation();
  const employeeApiKey: any = new URLSearchParams(search).get("employeeApiKey");
  const orgId = useSelector((state: any) => state?.organisationId?.id);

  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setType("");
    setCloseConfirmationModal(false);
    setOpen(false);
  };

  const handleLeaveRequest = () => {
    setLoading(true);

    const payload: object = {
      status: type === "approve" ? "approved" : "declined",
      employeeLeaveRequestId: approvalObject?.key,
      startDate: approvalObject?.from,
      endDate: approvalObject?.to,
      duration: approvalObject?.duration,
      reason: approvalObject?.reason,
      employeeApiKey: employeeApiKey,
      organisationId: orgId,
    };
    const params: object = {
      employeeLeaveRequestId: approvalObject.key,
    };

    leavePloicyApprovalApi(payload, {}, params)
      .then(() => getLeavePolicyApi())
      .then((res: any) => {
        triggerNotification("success", "", res?.message || (type === "approve" ? "Leave approved successfully" : "Leave declined successfully"), "topRight", 3);
        setLoading(false);
        handleClose();
      })

      .catch((err: any) => {
        triggerNotification("error", "Leave Request Failed", err?.response?.data?.detail || "Something went wrong", "topRight", 3);
        setLoading(false);
      });
  };

  return (
    <Modal className="close-confirmation-popup w-[545px]" centered open={open} onCancel={handleClose} footer={null} maskClosable={false}>
      <div className="appraisal-increment mt-4">
        <p className="font-medium">Do you want to {type} this request?</p>
        <div className="flex justify-end salary_add-btn mt-7">
          <Button className="addButton secondary mr-4" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button type="primary" className="addButton" loading={loading} onClick={handleLeaveRequest}>
            {type === "approve" ? "Approve" : "Decline"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
